const mixinsPagination = {
  data() {
    return {
      currentPage: 1,
      currentData: [], //分页后又搞了个数组

      lengthArr: [],
      lengthMap: {},
      length: 0,
      alloverflow: false //
    };
  },

  watch: {
    activeSectionData: {
      handler: function (newVal) {
        this.length = 0;
        this.currentPage = 1;
        newVal &&
          newVal.forEach(item => {
            this.length += parseInt(item.items.length);
            this.lengthArr.push(this.length);
            this.lengthMap[item.title] = item.items.length;
          });
        this.alloverflow = newVal.every(item => item.items.length > this.max);
        !this.hideContent && this.handleCurrentChange();
        this.hideContent && (this.currentData = newVal);
      },
      immediate: true
    }
  },

  methods: {
    handleCurrentChange(val = 1) {
      this.currentPage = Number(val);
      // 一页10条 0-9 10-20
      const startIndex = (this.currentPage - 1) * this.pageSize, // 开始索引
        endIndex = this.currentPage * this.pageSize - 1; // 结束的数据
      const startGetDataIndex = this.calcDataArea(startIndex);
      const endGetDataIndex = this.calcDataArea(endIndex);
      let i = startGetDataIndex;
      this.currentData = [];
      while (i <= endGetDataIndex && i < this.activeSectionData.length) {
        let sIdx = startIndex - (this.lengthArr[i - 1] || 0);
        sIdx = sIdx > 0 ? sIdx : 0;
        let eIdx = endIndex - (this.lengthArr[i - 1] || 0);
        eIdx = eIdx > 0 ? eIdx : 0;
        this.currentData.push({
          items: this.activeSectionData[i].items.slice(sIdx, eIdx + 1),
          title: this.activeSectionData[i].title
        });
        i += 1;
      }
      this.$forceUpdate();
    },

    calcDataArea(index) {
      //如果值小于最小的值时，则返回0
      let idx = 0;

      if (index < Math.min.apply(null, this.lengthArr)) {
        idx = 0;
      }
      //如果值大于最大的值时，则返回最高
      if (index > Math.max.apply(null, this.lengthArr)) {
        idx = this.lengthArr.length;
      }
      let j = this.lengthArr.length;
      for (let i = 0; i < j; i++) {
        if (this.lengthArr[i] >= index) {
          idx = i;
          break;
        }
      }
      return idx;
    }
  }
};

export default mixinsPagination;
